import { columns } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/columns/columns";

const {
    favorite,
    industry,
    previousPeriodTotalVisits,
    currentPeriodTotalVisits,
    periodOverPeriodTotalVisitsChange,
    previousPeriodUniqueVisitors,
    currentPeriodUniqueVisitors,
    periodOverPeriodUniqueVisitorsChange,
} = columns;

export const periodOverPeriodColumns = [
    favorite,
    { ...industry, fixed: true },
    previousPeriodTotalVisits,
    currentPeriodTotalVisits,
    periodOverPeriodTotalVisitsChange,
    previousPeriodUniqueVisitors,
    currentPeriodUniqueVisitors,
    periodOverPeriodUniqueVisitorsChange,
];
